<template>
  <fullscreen-view class="email-selection">
    <template #header>
      <button class="button cancel-button" @click="$emit('closeEmailTemplateSelectionModal')">cancel</button>
      <button class="button blank-template-button" @click="$emit('openEmailCreationModalAndSetTemplate', { layout_json: '{}' })">new template</button>
    </template>
    <template #content>
      <div v-for="(template, index) in email.specific_merchant_templates" :key="`merchant-${index}`" class="select-template">
        <a @click="$emit('openEmailCreationModalAndSetTemplate', template)">
          <template v-if="template.preview_image">
            <img :src="template.preview_image" :alt="template.title" />
          </template>
          <template v-else>
            <div style="align-self: center; text-align: center">
              <span class="negative">generating template please wait...</span>
            </div>
          </template>
        </a>
      </div>
      <div v-for="(template, index) in email.global_templates" :key="`global-${index}`" class="select-template">
        <a @click="$emit('openEmailCreationModalAndSetTemplate', template)">
          <template v-if="template.preview_image">
            <img :src="template.preview_image" :alt="template.title" />
          </template>
          <template v-else>
            <div style="align-self: center; text-align: center">
              <span class="negative">generating template please wait...</span>
            </div>
          </template>
        </a>
      </div>
    </template>
    <template #footer></template>
  </fullscreen-view>
</template>

<script>
import { FullscreenView } from "@springbig/sb-components";

export default {
  props: {
    email: Object
  },

  name:"email-template-selection",

  components: {FullscreenView}
}
</script>

<style scoped>
.email-selection {
  display: flex;
  flex-direction: column;
}

.email-selection >>> header {
  align-items: center;
  background-color: #128ff933;
  display: flex;
  flex-direction: row;
  justify-content: space-between !important;
  height: 100px;
}

.email-selection >>> .button.cancel-button {
  background-color: transparent;
  color: #128ff9;
  font-family: "AileronThin";
  font-size: 18px;
  height: 58px;
  line-height: 1em;
  margin: 15px 30px 15px 0;
}

.email-selection >>> .button.blank-template-button {
  font-family: "AileronThin";
  font-size: 18px;
  height: 58px;
  line-height: 1em;
  margin: 15px 30px 15px 0;
}

.email-selection >>> .button.design-button {
  font-family: "AileronThin";
}

.email-selection >>> .content {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  overflow-y: auto;
  padding: 15px;
  width: 100%;
}

.email-selection .negative {
  color: #a4a4a4;
}

.email-selection .bolder {
  font-weight: 700;
}

.email-selection .pb-15 {
  padding-bottom: 15px;
}

.email-selection >>> .select-template{
  align-items: center;
  border-radius: 8px;
  border: 1px solid #128ff9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 8px;
  height: 200px;
  overflow: auto;
  padding: 15px;
  width: 200px;
}

.email-selection >>> .select-template:hover {
  border-color: #016fb9;
}

.email-selection >>> .select-template a {
  align-items: start;
  display: flex;
  height: 100%;
}

.email-selection >>> .select-template img {
  height: auto;
}
</style>